import {
  Alert,
  AlertDescription,
  AlertIcon,
  AlertTitle,
  Box,
  Center, Heading, Spinner, Stack, Text as ChakraText, useDisclosure
} from '@chakra-ui/react'
import { Elements } from '@stripe/react-stripe-js'
import { loadStripe } from '@stripe/stripe-js'
import moment from 'moment'
import React, { useContext, useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import useFetch, { CachePolicies } from 'use-http'
import { BaseLayout } from '..'
import { colors } from '../../../ui-kit'
import {
  CancelSubscriptionModal,
  PlanChangeModal, PlanUpgradeModal
} from '../../components/Billing'
import { Plans } from '../../components/Billing/PlanUpgrade/NewPlan'
import { UserContext } from '../../providers'
import { MainContentHeadingBox, MainContentWrapper } from '../Base/MainContent'

const Layout = (): React.ReactElement | null => {
  const { t } = useTranslation()

  const [selectedPlanId, setSelectedPlanId] = React.useState<string>('')

  const {
    isOpen: isOpenPlanUpgrade,
    onClose: onClosePlanUpgrade,
    onOpen: onOpenPlanUpgrade,
  } = useDisclosure()

  const {
    isOpen: isOpenCancelSubscription,
    onClose: onCloseCancelSubscription,
    onOpen: onOpenCancelSubscription,
  } = useDisclosure()

  const { isOpen: isOpenPlanChange, onClose: onClosePlanChange, onOpen: onOpenPlanChange } = useDisclosure()

  const { user } = useContext(UserContext)

  if (!user) {
    return null
  }

  const stripePromise = loadStripe(user.stripePublishKey)

  return (
    <>
      <BaseLayout>
        <MainContentHeadingBox>
          <Stack direction={['column']} spacing={1}>
            <Heading
              as="h2"
              size="md"
              fontWeight="600"
              color={colors.appDarkIndigo}
            >
              Change your plan
            </Heading>
            <ChakraText color="appBattleshipGrey">
              Modify your plan to suit your needs. You can upgrade or downgrade at any time.
            </ChakraText>
          </Stack>

        </MainContentHeadingBox>
        <MainContentWrapper>
          <Box alignSelf={"center"}>
            <Plans user={user} onSelect={(plan, currentPlan) => {
              // Enterprise enquire
              if (plan.isEnterprise) {
                window.open('https://imagekit.io/contact-us/', '_blank')
                return;
              }
              // Downgrade
              if (!plan.isPaidPlan && currentPlan.isPaidPlan) {
                onOpenCancelSubscription();
                return;
              }
              // Upgrade
              if (plan.isPaidPlan && !currentPlan.isPaidPlan) {
                setSelectedPlanId(plan.planId)
                onOpenPlanUpgrade()
                return;
              }
              // Change plan
              if (currentPlan.isPaidPlan && plan.isPaidPlan) {
                setSelectedPlanId(plan.planId)
                onOpenPlanChange()
                return;
              }
            }} />
          </Box>
        </MainContentWrapper>
      </BaseLayout>
      <Elements stripe={stripePromise}>
        <PlanUpgradeModal
          isOpen={isOpenPlanUpgrade}
          onClose={onClosePlanUpgrade}
          user={user}
          selectedPlanId={selectedPlanId}
        />
      </Elements>
      <CancelSubscriptionModal
        isOpen={isOpenCancelSubscription}
        onClose={onCloseCancelSubscription}
        user={user}
      />
      <PlanChangeModal
        isOpen={isOpenPlanChange}
        onClose={onClosePlanChange}
        user={user}
        selectedPlanId={selectedPlanId}
      />
    </>
  )
}

export default Layout
